















import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

import DigitalCurrency3CreateTransaction from '../digital-currency-3-create-transaction.vue'

@Component({
  components: {
    DigitalCurrency3CreateTransaction
  }
})
class DigitalCurrencyTransaction3CopyTransactionButton extends Vue {
  @Prop({ default: false }) isIconButton?: boolean
  @Prop({ default: false }) isDepressedButton?: boolean

  @Prop({ default: null }) initialTransaction?: any

  isVisibleCreateTransactionDialog: boolean = false

  toggleShowContent ({ isVisible }: { isVisible: boolean }) {
    this.isVisibleCreateTransactionDialog = isVisible
  }
}

export default DigitalCurrencyTransaction3CopyTransactionButton

